import React from 'react'

import styles from './search.module.css'
import SearchIcon from '@mui/icons-material/Search';

const SearchInput = ({ width = 500,value, onChange }) => {
    const localOnChange = ({target: {value}}) => onChange(value)

    return (
        <div style={{ width: width }} className={styles.searchContainer}>
            <SearchIcon className={styles.searchIcon}/>

            <input value={value} className={styles.search} onChange={localOnChange}/>            
        </div>
    )
}

export default SearchInput